<div class="flex items-center gap-1 w-auto" [class.w-full]="fullWidth()">
  <p-checkbox
    [inputId]="inputId()"
    [binary]="binary()"
    [trueValue]="trueValue()"
    [falseValue]="falseValue()"
    [disabled]="disabled()"
    [ngModel]="value()"
    (onChange)="onInputCheckBox($event)"
    (blur)="onBlur()"
    [ngClass]="{
      'ng-invalid ng-dirty': hasErrorSignal(),
    }"
  />

  @if (label()) {
    <label [for]="inputId()">{{ label() | translateKey }}</label>
  }
</div>
